import React, { FC } from 'react';
import { IconProps } from '.';

export const PromulgationIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...sizing} {...props}>
            <path
                fill="currentColor"
                d="M14.97 15.91a3.36 3.36 0 0 1 1.11 2.41c0 1.8-.88 2.94-2.64 3.44l.28-1.45c.37-.33.55-.82.55-1.46 0-.87-.7-1.75-2.1-2.64l-1.21-.8a10.82 10.82 0 0 1-2.17-1.68 4.28 4.28 0 0 1-1.15-2.8c0-1.23.47-2.18 1.42-2.84a3.41 3.41 0 0 1-1.05-2.4c0-1.09.44-1.98 1.31-2.67A5.03 5.03 0 0 1 12.6 2c1.09 0 2 .26 2.73.78a1 1 0 0 1 .38 1.06c-.22.8-1.19.72-1.83.22a3.17 3.17 0 0 0-1.95-.78c-.93 0-1.57.35-1.92 1.07a1.92 1.92 0 0 0 .1 1.83c.2.3.44.6.74.87.32.28.67.55 1.06.81l1.2.8a11.1 11.1 0 0 1 2.12 1.73 4.2 4.2 0 0 1 1.15 2.75c0 1.24-.47 2.17-1.4 2.77ZM9.68 8.67A2 2 0 0 0 9.23 10c0 .53.08.96.23 1.3.16.34.37.65.63.94.27.28.57.56.92.82.34.25.7.5 1.07.74l1.15.75c.38.25.74.51 1.07.77.3-.36.44-.8.44-1.32 0-.51-.08-.94-.24-1.27a3.66 3.66 0 0 0-.63-.94 6.67 6.67 0 0 0-.91-.82 19 19 0 0 0-1.08-.77l-1.13-.75c-.38-.25-.74-.5-1.07-.78Z"
            />
            <path
                fill="url(#150d4af9)"
                d="M11.65 22a6.4 6.4 0 0 0 1.8-.25l.28-1.45c-.18.15-.4.26-.63.33a3.57 3.57 0 0 1-1.9-.06 5.54 5.54 0 0 1-1.6-.78c-.63-.44-1.54-.5-1.76.23a1 1 0 0 0 .47 1.14c.96.56 2.08.84 3.34.84Z"
            />
            <defs>
                <linearGradient id="150d4af9" x1="14.12" x2="8.12" y1="21.02" y2="20.39" gradientUnits="userSpaceOnUse">
                    <stop offset=".15" stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
